import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { Partner } from '../../models/stack9/Partner';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

type CountrySetupDrawerProps = {
  open: boolean;
  onClose: () => void;
  id?: number;
  initialValues?: Partner;
};

export const CountrySetupDrawer = ({
  open,
  onClose,
  id,
  initialValues,
}: CountrySetupDrawerProps) => {
  const formFields = [{ field: 'country' }];

  return (
    <EntityDrawer
      title="country setup"
      open={open}
      id={id}
      formFields={formFields}
      initialValues={initialValues}
      onClose={onClose}
      screenQueryName={EDetailsQueryNames.GetCountrySetupDetails}
      entityName={entityNames.COUNTRY_SETUP}
      editRoute={AppRoutes.CountrySetupDetail}
      relativePath={AppRoutes.CountrySetupDetail}
    />
  );
};
